import { render, staticRenderFns } from "./MarketPriceDetailModal.vue?vue&type=template&id=fb2903a2&scoped=true"
import script from "./MarketPriceDetailModal.vue?vue&type=script&lang=js"
export * from "./MarketPriceDetailModal.vue?vue&type=script&lang=js"
import style0 from "./MarketPriceDetailModal.vue?vue&type=style&index=0&id=fb2903a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2903a2",
  null
  
)

export default component.exports